const DAY_MS = 24 * 60 * 60 * 1000;

const dateTime = (value) => {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
};

export const formatPpmReportDate = (value) => {
  const time = dateTime(value);
  return time === null ? 'Not set / invalid' : new Date(time).toLocaleString('en-GB');
};

export const buildPendingPpmReport = (entries, asOf, filters = {}) => {
  const now = dateTime(asOf);
  if (now === null) throw new Error('A valid report date is required');

  const rows = entries
    .filter((entry) => (
      entry.maintenanceType?.trim().toLowerCase() === 'preventive' &&
      ['active', 'on hold'].includes(entry.scStatus?.trim().toLowerCase())
    ))
    .map((entry) => {
      const dueTime = dateTime(entry.targetResolution);
      const overdue = dueTime !== null && dueTime < now;
      return {
        ...entry,
        dueTime,
        overdue,
        daysOverdue: overdue ? Math.ceil((now - dueTime) / DAY_MS) : 0,
        timing: dueTime === null ? 'No due date' : overdue ? 'Overdue' : 'Within deadline',
        place: [entry.location, entry.zone && `Zone ${entry.zone}`].filter(Boolean).join(' / '),
      };
    })
    .filter((row) => (
      (!filters.location || row.location === filters.location) &&
      (!filters.ppmType || row.ppmType === filters.ppmType) &&
      (!filters.timing || row.timing === filters.timing)
    ))
    .sort((a, b) => (
      Number(b.overdue) - Number(a.overdue) ||
      (a.dueTime ?? Infinity) - (b.dueTime ?? Infinity) ||
      (a.scNumber || '').localeCompare(b.scNumber || '')
    ));

  const groups = new Map();
  rows.forEach((row) => {
    const key = JSON.stringify([row.location, row.ppmType]);
    if (!groups.has(key)) {
      groups.set(key, {
        key, location: row.location || 'Not set', ppmType: row.ppmType || 'Not set',
        pending: 0, overdue: 0, onHold: 0, noDueDate: 0,
      });
    }
    const group = groups.get(key);
    group.pending += 1;
    group.overdue += Number(row.overdue);
    group.onHold += Number(row.scStatus.trim().toLowerCase() === 'on hold');
    group.noDueDate += Number(row.dueTime === null);
  });

  return {
    asOf: new Date(now).toISOString(),
    filters: { ...filters },
    rows,
    groups: [...groups.values()].sort((a, b) => (
      a.location.localeCompare(b.location) || a.ppmType.localeCompare(b.ppmType)
    )),
    pending: rows.length,
    overdue: rows.filter((row) => row.overdue).length,
    onHold: rows.filter((row) => row.scStatus.trim().toLowerCase() === 'on hold').length,
    noDueDate: rows.filter((row) => row.dueTime === null).length,
  };
};
